import { useEffect, useRef } from "react";
import MinerProfileFields from "@components/Pages/Managment/MinerPrifilesInfo/MinerProfileFields/MinerProfileFields";
import styles from "./CreateMinerProfile.module.scss";
import { ICreateMinerProfileProps } from "./CreateMinerProfile.props";
import { useCreateMinerProfileControl } from "./useCreateMinerProfileControl";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import Title from "@components/global/new/Title/Title";
import Error from "@components/global/new/Error/Error";
import { Button } from "antd";

function CreateMinerProfile(props: ICreateMinerProfileProps) {
  const control = useCreateMinerProfileControl(props);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "fit-content";
    }
  }, [ref]);
  return (
    <div className={styles.wrapper} ref={ref}>
      <Title>{props.formatMessage({ id: "modal.create_profile.title" })}</Title>
      <form onSubmit={control.onSubmit}>
        <MinerProfileFields errors={control.errors} />
        {control.errors && <Error errors={{ fill: true }} />}
        <div className={styles.btns}>
          <Button onClick={props.handleClose}>
            {props.formatMessage({ id: "modal.change_pass.cancel" })}
          </Button>
          <Button htmlType="submit" type="primary" loading={control.loading}>
            {props.formatMessage({ id: "modal.create_plan.btn.create" })}
          </Button>
        </div>
      </form>
    </div>
  );
}
export default WithModal(
  MODALS_ENUM.MINERS_PROFILE_CREATE_MODAL,
  CreateMinerProfile
);
